import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';

// Simple cache for link previews
const previewCache = new Map();

const LinkPreview = ({ url, isOwn }) => {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        setLoading(true);
        setError(false);
        
        // Check cache first
        if (previewCache.has(url)) {
          const cachedPreview = previewCache.get(url);
          if (cachedPreview.error) {
            setError(true);
          } else {
            setPreview(cachedPreview);
          }
          setLoading(false);
          return;
        }
        
        const response = await axios.post(`${config.apiUrl}/api/messages/link-preview`, {
          url: url
        });
        
        if (response.data && response.data.success) {
          const previewData = response.data.data;
          setPreview(previewData);
          previewCache.set(url, previewData);
        } else {
          setError(true);
          previewCache.set(url, { error: true });
        }
      } catch (err) {
        //console.error('Error fetching link preview:', err);
        setError(true);
        previewCache.set(url, { error: true });
      } finally {
        setLoading(false);
      }
    };

    if (url) {
      // Add a small delay to avoid too many simultaneous requests
      const timer = setTimeout(fetchPreview, 300);
      return () => clearTimeout(timer);
    }
  }, [url]);

  if (loading) {
    return (
      <div className={`link-preview loading ${isOwn ? 'own' : ''}`}>
        <div className="link-preview-loading">
          <div className="loading-spinner"></div>
          <span>Loading preview...</span>
        </div>
      </div>
    );
  }

  if (error || !preview) {
    return null;
  }

  const handlePreviewClick = (e) => {
    e.stopPropagation();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className={`link-preview notranslate ${isOwn ? 'own' : ''}`}
      onClick={handlePreviewClick}
    >
      {preview.image && (
        <div className="link-preview-image">
          <img 
            src={preview.image} 
            alt={preview.title || 'Link preview'} 
            onError={(e) => {
              e.target.parentElement.style.display = 'none';
            }}
          />
        </div>
      )}
      <div className="link-preview-content">
        {preview.title && (
          <div className="link-preview-title">{preview.title}</div>
        )}
        {preview.description && (
          <div className="link-preview-description">{preview.description}</div>
        )}
        <div className="link-preview-url">{new URL(url).hostname}</div>
      </div>
    </div>
  );
};

export default LinkPreview;